import { ObjectFullPaths } from '../app';
import { cardAdmin } from './content/card-admin';
import { vippsWidget } from './content/vipps-widget';

export const translations = {
    pay: {
        submitPayment: 'Betal',
        payeeField: {
            title: 'Til',
            subTitle: 'Betal til',
            placeholder: 'Legg til mottaker',
        },
        payeeModalTitle: 'Betal til',
        payeeModalNameLabel: 'Navn',
        payeeModalNamePlaceholder: 'Legg til navn eller bedrift',
        payeeModalAccountNumberLabel: 'Kontonummer',
        field: {
            amount: {
                costsInfo: 'Gebyr: 25 kr pluss 1 % av beløpet',
                costsSummary: 'Gebyr: 25 kr pluss 1 % av beløpet, totalt {}',
            },
        },
        validation: {
            te_transfer: {
                amount: {
                    low: 'Beløpet kan ikke være mindre enn {minAmount}',
                    high: 'Beløpet kan ikke være større enn {maxAmount}',
                },
            },
            account: {
                ownership: 'Klarte ikke å verifisere kontoeierskap',
                invalid: 'Ugyldig kontonummer',
            },
            payeeAccountNumber: {
                required: 'Du må velge en konto',
                invalid:
                    'Betalinger fra kort krever KID-nummer. Denne mottakeren støtter ikke det. Sjekk om konto er riktig, eller betal fra en brukskonto',
                ocrInvalid:
                    'Obs vi klarer ikke å finne om kontoen er registrert for OCR giro, sjekk om  konto er riktig og prøv igjen.',
            },
            payeeName: {
                required: 'Du må skrive navnet på mottakeren',
            },
            amount: {
                required: 'Du må skrive inn beløp',
                minValue: 'Beløpet kan ikke være mindre enn 100 kr',
                noMoney: 'Det er ikke nok penger på kontoen',
            },
            kid: {
                illegalLength: 'KID må være mellom 2 og 25 tegn',
                invalid: 'KID-nummer er ikke gyldig',
                required: 'Kid er påkrevd',
            },
        },
    },
    cardAdmin,
    vippsWidget,
} as const;

export type Translations = typeof translations;
export type TranslationsFullPath = ObjectFullPaths<Translations>;
